'use client';

import type { ReactNode } from 'react';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { AuthSessionContext, type SessionPayload, type SessionState } from './auth/useAuthSession';

export default function AuthSessionProvider({ children }: { children: ReactNode }) {
  const [data, setData] = useState<SessionPayload | null>(null);
  const [status, setStatus] = useState<SessionState['status']>('loading');

  const refresh = useCallback(async () => {
    setStatus('loading');
    try {
      const res = await fetch('/api/auth/session', {
        cache: 'no-store',
        credentials: 'include',
      });
      const payload = await res.json();
      const session = payload?.session ?? null;
      setData(session);
      setStatus(session?.user ? 'authenticated' : 'unauthenticated');
    } catch {
      setData(null);
      setStatus('unauthenticated');
    }
  }, []);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  const value = useMemo(() => ({ data, status, refresh }), [data, status, refresh]);

  return <AuthSessionContext.Provider value={value}>{children}</AuthSessionContext.Provider>;
}
